/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-return-assign */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import CustomLabelSettingsForm from './CustomLabel.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomLabel = class extends Component {
  render() {
    const { props: { component: { hideCustomLabel, label, tooltipTitle, tooltip, translationId }, intl } } = this;
    return (
      <>
        {!hideCustomLabel && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <label className="label-question">
              <FormattedMessage id={translationId || label} defaultMessage={translationId || label} />
            </label>
            {this.props.component.tooltip !== '' && (
              <Tooltip id="label_tooltip" primary title={intl.formatMessage({ id: tooltipTitle, defaultValue: tooltipTitle })}>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
            )}
          </div>
        )}
      </>
    );
  }
};

const CustomTextFieldWithIntl = injectIntl(CustomLabel);

export default class LabelComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Label',
      icon: 'terminal',
      group: 'basic',
      documentation: '',
      schema: LabelComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customlabel',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomLabelSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomTextFieldWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
